import { InfosetsStore } from '@/overmind/localStorage';
import http from '@/services/axios.service';
import { getApiExportBaseUrl, getCrmBaseUrl, } from '@/shared/utils/helpers';
import axios from 'axios';
import { isEmpty } from 'lodash';
import { createCancelTokenHandler } from '@/overmind/cancelationHandler';
import { createWriteStream } from 'streamsaver';
import Vue from 'vue';
import * as Sentry from '@sentry/browser';
var EndPoint;
(function (EndPoint) {
    EndPoint["INFOSETS"] = "info_sets";
    EndPoint["PROGRESS"] = "progress";
})(EndPoint || (EndPoint = {}));
export const storage = {
    async getInfosets() {
        return await InfosetsStore.keys().then(function (keys) {
            return Promise.all(keys.map(function (key) {
                return InfosetsStore.getItem(key).then(function (value) {
                    return { key: key, value: value };
                });
            }));
        });
    },
};
function unwrapCrmResponse(res) {
    if (res.data && res.data.message !== undefined) {
        return res.data.message;
    }
    return (res.data || { ok: false });
}
function crmAuthHeaders() {
    return {
        'x-atlas-token': localStorage.getItem('auth_token_default'),
    };
}
async function postCrmMethod(url, body) {
    const cleanAxios = axios.create();
    try {
        const res = await cleanAxios.post(url, body, { headers: crmAuthHeaders() });
        return unwrapCrmResponse(res);
    }
    catch (err) {
        Sentry.captureException(err);
        const axiosErr = err;
        const res = axiosErr.response;
        if (res && res.data && res.data.message !== undefined) {
            return res.data.message;
        }
        return { ok: false };
    }
}
export const infosetsApi = {
    async fetchAll({ updatedAt = undefined, page = 1, query = '', } = {}) {
        let path = '';
        if (updatedAt) {
            path = `?updated_at=${updatedAt}`;
        }
        else
            path = '';
        return await Vue.axios
            .get(`${EndPoint.INFOSETS}${path}?skip_handle_error`, {
            params: {
                page,
                query,
            },
            cancelToken: cancelTokenHandlerObject[this.fetchAll.name].handleRequestCancellation().token,
        })
            .then(res => res)
            .catch((err) => err.response);
    },
    async getInfosetById(infosetId) {
        if (infosetId) {
            return await Vue.axios
                .get(`${EndPoint.INFOSETS}/${infosetId}?skip_handle_error`)
                .then(res => res)
                .catch((err) => err.response);
        }
        return;
    },
    async fetchAllMembersAvailable() {
        return await Vue.axios
            .get('user/supervised_users_to_share_list')
            .then(res => res)
            .catch(err => err);
    },
    async fetchInfosetOverview(infosetId) {
        if (!infosetId) {
            // Fetch Overview for all infosetlist
            return await http
                .get(`${EndPoint.INFOSETS}/5d6f04379807027c991b06f0/infosets_overviews`)
                .then(res => res)
                .catch(err => err);
        }
        // Fetch Overview for one specific infoset
        return await http
            .get(`${EndPoint}/${infosetId}/overviews`)
            .then(res => res)
            .catch(err => err);
    },
    async create(infoset, autoplayActive) {
        if (infoset.id)
            delete infoset.id;
        return await Vue.axios
            .post(`${EndPoint.INFOSETS}`, {
            info_set: { ...infoset },
            autoplayActive: autoplayActive,
        })
            .then(res => res)
            .catch(err => err);
    },
    async update(infosetId, infoset) {
        const data = {
            id: infosetId,
            name: infoset.name,
            star: infoset.star,
            company_count: infoset.contacts,
            archived: infoset.archived,
        };
        return await Vue.axios
            .patch(`${EndPoint.INFOSETS}/${infosetId}`, { info_set: { ...data } })
            .then(res => res)
            .catch(err => err);
    },
    async recover(infosetId) {
        return await Vue.axios
            .post(`${EndPoint.INFOSETS}/${infosetId}/recover`)
            .then(res => res)
            .catch(err => err);
    },
    async delete(infosetId) {
        return await Vue.axios
            .delete(`${EndPoint.INFOSETS}/${infosetId}`)
            .then(res => res)
            .catch(err => err);
    },
    async addMembersToInfoset(infosetId, member) {
        const payload = {
            user_id: member.id,
        };
        // TODO: handle body post object to send to the server
        if (infosetId) {
            return await Vue.axios
                .post(`${EndPoint.INFOSETS}/${infosetId}/coordinator`, payload)
                .then(res => res)
                .catch(err => err);
        }
    },
    async removeMembersToInfoset(infosetId, member) {
        if (infosetId) {
            return await Vue.axios
                .delete(`${EndPoint.INFOSETS}/${infosetId}/coordinator?user_id=${member.id}`)
                .then(res => res)
                .catch(err => err);
        }
    },
    async createExportFileStream(response, filename) {
        const fileStream = createWriteStream(filename);
        const writer = fileStream.getWriter();
        // @ts-ignore
        if (response.body.pipeTo) {
            writer.releaseLock();
            return response.body.pipeTo(fileStream);
        }
        const reader = response.body.getReader();
        const pump = () => reader
            .read()
            .then(({ value, done }) => done ? writer.close() : writer.write(value).then(pump));
        return pump();
    },
    async export(infosetId, fileName, payload) {
        let url = `${getApiExportBaseUrl()}/export/${infosetId}/sheet`;
        // excel or csv service can be excel-companies, excel-decisors, etc...
        // so than we extract just the part of string we interested on
        const service = payload.service.split('-')[0];
        if (['excel', 'csv'].includes(service) && url.match('app')) {
            url = `https://integrations.app.secondary.speedio.com.br/export/${infosetId}/sheet`;
        }
        return Vue.axios
            .post(url, {
            ...payload,
            token: localStorage.getItem('auth_token_default'),
        })
            .then(async (res) => res)
            .catch(err => err.response);
    },
    async calculateExports(infosetId, payload) {
        const url = `${getApiExportBaseUrl()}/export/${infosetId}/calculate?skip_handle_error`;
        return await Vue.axios
            .post(url, payload)
            .then(res => res)
            .catch(err => err.response);
    },
    async calculateExistingCompaniesOnTotvs(infosetId) {
        const url = `${getApiExportBaseUrl()}/export/${infosetId}/calculate_existing_companies_on_totvs?skip_handle_error`;
        return await Vue.axios
            .get(url)
            .then(res => res)
            .catch(err => err.response);
    },
    async cancelExportation(eventId) {
        const url = `${getApiExportBaseUrl()}/export/${eventId}/cancelExport`;
        return await Vue.axios
            .post(url)
            .then(res => res)
            .catch(err => err);
    },
    async getInfosetExportationsInProgress(accountId, infosetId) {
        const url = `${getApiExportBaseUrl()}/export/${accountId}/${infosetId}/exportations_in_progress`;
        return await Vue.axios
            .get(url)
            .then(res => res)
            .catch(err => err.response);
    },
    async getInfosetExportationInProgressByService(infosetId, service) {
        const url = `${getApiExportBaseUrl()}/export/${infosetId}/exportation_in_progress/${service}`;
        return await Vue.axios
            .get(url)
            .then(res => res)
            .catch(err => err.response);
    },
    async getExportationByEventID(infosetId, eventID) {
        const url = `${getApiExportBaseUrl()}/export/${infosetId}/exportation_status/${eventID}`;
        return await Vue.axios
            .get(url)
            .then(res => res)
            .catch(err => err.response);
    },
    async getInfosetsOverview(infosetId, userId) {
        return await Vue.axios
            .get(`${EndPoint.INFOSETS}/${infosetId}/overview/user/${userId}`)
            .then(res => res)
            .catch(err => err);
    },
    async checkCrmSyncNeeded(infosetId) {
        const url = `${getCrmBaseUrl()}/api/method/speedio.api.atlas_sync.check_info_set_sync_needed`;
        return postCrmMethod(url, { infoSetId: infosetId });
    },
    async exportToCrm(listId) {
        const importUrl = `${getCrmBaseUrl()}/api/method/speedio.api.atlas_sync.import_list`;
        return postCrmMethod(importUrl, {
            listId,
            background: true,
        });
    },
    handleInfosetsListResult(r) {
        const data = r.data;
        const buildInfosets = (infosets) => infosets.map((i) => ({
            id: i.id.$oid,
            name: i.name,
            contacts: i.contacts,
            author: buildInfosetAuthor(i.author),
            star: i.star.toString(),
            updatedAt: new Date(i.updated_at).getTime(),
            deletedAt: i.deleted_at ? new Date(i.deleted_at).getTime() : null,
            createdAt: new Date(i.created_at).getTime(),
            members: i.members.map((m) => {
                return {
                    id: m.id.$oid,
                    email: m.email,
                    name: m.name,
                };
            }),
            emailsValidationStatus: i.emails_validation_status,
            emailsValidationStartedAt: i.emails_validation_started_at,
            phonesValidationStatus: i.phones_validation_status,
            phonesValidationStartedAt: i.phones_validation_started_at,
            search_ids: i.search_ids,
            hasWhatsapp: i.has_whatsapp,
        }));
        const buildInfosetAuthor = (author) => {
            if (isEmpty(author))
                return;
            return {
                id: author.id ? author.id['$oid'] : '',
                name: author.name,
                email: author.email,
                role: author.role,
            };
        };
        return {
            ...r,
            data: {
                infosets: buildInfosets(data.info_sets.data),
                page: data.info_sets.metadata.length
                    ? data.info_sets.metadata[0].page
                    : 1,
                infosets_total: data.info_sets.metadata.length
                    ? data.info_sets.metadata[0].total
                    : 0,
            },
        };
    },
    getAuthorData(included, authorData) {
        if (authorData && authorData.data) {
            const author = included.find(item => item.id === authorData.data.id);
            if (author) {
                return {
                    id: author.id,
                    name: author.attributes.name,
                };
            }
            else {
                return undefined;
            }
        }
        return undefined;
    },
    buildInfoset(result) {
        const buildUpdatedAt = val => {
            return val * 1000;
        };
        const authorId = result.data.relationships.author.data.id;
        const members = result.included
            .filter(user => user.id !== authorId)
            .map(({ id, attributes }) => ({
            id,
            name: attributes.name,
            email: attributes.email,
        }));
        return {
            id: result.data.id,
            name: result.data.attributes.name,
            description: result.data.attributes.description,
            archived: result.data.attributes.archived,
            contacts: result.data.attributes.companies_count,
            members: members,
            star: result.data.attributes.star.toString(),
            updatedAt: buildUpdatedAt(result.data.attributes.updated_at),
            createdAt: result.data.attributes.created_at,
            // `getAuthorData` pede `{ data: Author }`; passando o `.data` o autor
            // voltava vazio em toda lista carregada por id.
            author: this.getAuthorData(result.included, result.data.relationships.author),
            // Sem isto, quem carrega o infoset pelo detalhe (arvore hiperbolica) fica
            // sem as buscas de origem, ainda que a API as devolva.
            search_ids: result.data.attributes.search_ids,
        };
    },
    async downloadExportationFile({ eventId, infosetId, }) {
        const url = `${getApiExportBaseUrl()}/export/${infosetId}/files?eventId=${eventId}`;
        return await Vue.axios({
            url,
            method: 'GET',
            responseType: 'blob',
            timeout: 1200000,
            data: {
                token: localStorage.getItem('auth_token_default'),
            },
        })
            .then(res => res)
            .catch(err => err);
    },
    async accuracyDataFeedback(data) {
        return await Vue.axios
            .post('accuracy_data_feedback/create', data)
            .then(res => res)
            .catch((err) => err.response);
    },
    async getProgress(infoset_id) {
        return await Vue.axios
            .get(`${EndPoint.INFOSETS}/${infoset_id}/${EndPoint.PROGRESS}`)
            .then(res => res)
            .catch((err) => err.response);
    },
};
// creating the cancel token handler object
const cancelTokenHandlerObject = createCancelTokenHandler(infosetsApi);
